import { useEffect, useState } from "react";
import { getPlanList, getPersonelTask, postPersonelTask , getPersonelComeToWork, deletePlan} from "../services/addressService";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import "../styles/pages/_route-plans.scss";// genellikle index.js veya App.js üstüne
import 'primereact/resources/themes/lara-light-blue/theme.css';  // veya başka bir tema
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import { getAllPersonelUsers,getuserTask } from "../services/userService";
import { Checkbox } from 'primereact/checkbox';
export default function RoutePlans() {
    const [planList, setPlanList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedPersonnel, setSelectedPersonnel] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentPlanId, setCurrentPlanId] = useState(null);
    const [currentPlanId2, setCurrentPlanId2] = useState(null);
    const [currentPersonnelId, setCurrentPersonnelId] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [personnelTasks, setPersonnelTasks] = useState([]);
    const [personnelWorks, setPersonnelWorks] = useState([]);
    const [selectedTasks, setSelectedTasks] = useState([]);
    const [users, setUsers] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const fetchUsers = async () => {
        try {
          const response = await getAllPersonelUsers();
          // Ensure response is an array
          const usersArray = Array.isArray(response) ? response : [];
          setUsers(usersArray);
        }
        catch (error) {
          console.error("Failed to fetch users:", error);
          setUsers([]);
        }
      }; 
      const fetchComeToWorkUsers = async () => {
        try {
          const response = await getPersonelComeToWork();
          setPersonnelWorks(response);
        }
        catch (error) {
          console.error("Failed to fetch users:", error);
        }
      };
    useEffect(() => {
        const fetchPlanList = async () => {
            setLoading(true);
            try {
                const res = await getPlanList();
                const sorted = res.data.slice().sort((a, b) => new Date(b.tarih) - new Date(a.tarih));
                setPlanList(sorted);
            } catch (err) {
                setError("Plan listesi alınamadı");
            } finally {
                setLoading(false);
            }
        }
        fetchPlanList();   fetchComeToWorkUsers(); fetchUsers(); 
    }, []);

    const ExportUserTask = async (planid) => {
        try {
          const response = await getuserTask( { planid }  );
          const blob = response.data;
          // Dosya oluşturma ve indirme işlemi
          const url = window.URL.createObjectURL(blob); 
          const link = document.createElement("a");
          const today = new Date().toLocaleDateString("tr-TR").replace(/\./g, "-");
          link.href = url;
          link.download = `gorevler-${today}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Failed to download full report:", error);
          setError("Rapor indirme işlemi başarısız oldu");
        } finally {
 
        }
      }
      const gunFilterTemplate = (options) => {
        return (
          <Dropdown
            value={options.value}
            options={days.map(day => ({ label: day, value: day }))}
            onChange={(e) => options.filterApplyCallback(e.value)} // ✅ burada düzeltildi
            placeholder="Gün Seçiniz"
            className="p-column-filter"
            showClear
          />
        );
      };
      
      const days = [
        "Pazartesi",
        "Salı",
        "Çarşamba",
        "Perşembe",
        "Cuma",
        "Cumartesi",
        "Pazar"
      ];
    const checkboxBody = (row) => (
        <Checkbox
            checked={selectedTasks.some(task => task.id === row.id)}
            onChange={(e) => {
                if (e.checked) {
                    setSelectedTasks([...selectedTasks, row]);
                } else {
                    setSelectedTasks(selectedTasks.filter(task => task.id !== row.id));
                }
            }}
        />
    );

    const sokaklarBody = (row) =>
        row.sokaklar
            ? row.sokaklar.length > 30
                ? row.sokaklar.slice(0, 30) + "..."
                : row.sokaklar
            : "-";

    const  handlePersonnelClick = async (planId, personnelId) => {
        setCurrentPlanId(planId);
        setCurrentPersonnelId(personnelId);
        setShowModal(true);
        try {
            const res = await getPersonelTask(planId, personnelId);
            setPersonnelTasks(res.data);
        } catch (err) {
            console.error("Failed to fetch personnel tasks:", err);
            setError("Personel görevleri alınamadı");
        }
    };
   
     const exportIcon = (row) => {
        if (!row.id) return "-"; 
                    return (
                        <Button  title="Excel olarak indir..."     icon="pi pi-file-excel"
                            key={row.id}
                            label={row.id}
                            className="p-button-sm p-button-outlined"
                            onClick={() => ExportUserTask(row.id)}
                        />
                    );
            
    };
    const personellerBody = (row) => {
        if (!row.personeller) return "-";
    
        // Users henüz gelmedi -> placeholder göster
        if (users.length === 0) {
            return (
                <div className="personnel-buttons">
                    {row.personeller.split(",").map((id) => (
                        <Button
                            key={id}
                            label="Yükleniyor..."
                            className="p-button-sm p-button-outlined"
                            disabled
                        />
                    ))}
                </div>
            );
        }
    
        const personnelIds = row.personeller.split(",");
    
        return (
            <div className="personnel-buttons">
                {personnelIds.map((id) => {
                    const trimmedId = parseInt(id.trim());
                    const user = users.find(user => user.id === trimmedId);
                    const label = user ? user.adSoyad : id;
    
                    const isWorked = Array.isArray(personnelWorks?.data) &&
                        personnelWorks.data.some(work => work.id === trimmedId);
    
                    return (
                        <Button
                            key={id}
                            label={label}
                            style={{
                                backgroundColor: isWorked ? "lightgreen" : "lightcoral",
                                color: !isWorked ? "white" : "black"
                            }}
                            className="p-button-sm p-button-outlined"
                            onClick={() => handlePersonnelClick(row.id, trimmedId)}
                        />
                    );
                })}
            </div>
        );
    };
    
    const gorevBody = (row) => {
        return (
          <div className="personnel-buttons">
            <Button
              key={0}
              label={'Listele'}
              className="p-button-sm p-button-outlined"
              onClick={() => handlePersonnelClick(row.id, 0)}
            />
          </div>
        );
      };

    const deleteBody = (row) => {
        return (
            <Button
                icon="pi pi-trash"
                className="p-button-danger p-button-outlined route-plans-delete-button"
                style={{ padding: '6px' }}
                onClick={() => handleDelete(row.id)}
            />
        );
    };
      
    const handleSelectAll = (e) => {
        setSelectAll(e.checked);
        if (e.checked) {
            setSelectedTasks([...personnelTasks]);
        } else {
            setSelectedTasks([]);
        }
    };

    const selectAllHeader = () => (
        <Checkbox
            checked={selectAll}
            onChange={handleSelectAll}
            tooltip="Tümünü Seç"
        />
    );
    const handleSave = async () => {
        try {
            if (!selectedUsers || (Array.isArray(selectedUsers) && selectedUsers.length === 0)) {
                alert("Önce personel seçiniz.");
                return;
            }
    
            const selectedTaskIds = selectedTasks.map(task => task.id).join(",");
            //alert(`${currentPlanId}-${currentPersonnelId}-${selectedUsers}-${selectedTaskIds}`);

            // Replace with your actual API call
            await postPersonelTask(selectedUsers, selectedTaskIds);
            setShowModal(false);
            setSelectedPersonnel(null);
            setSelectedTasks([]);
            setSelectAll(false);
            // Optionally refresh plan list
            const res = await getPlanList();
            const sorted = res.data.slice().sort((a, b) => new Date(b.tarih) - new Date(a.tarih));
            setPlanList(sorted);
        } catch (err) {
            alert("Personel atama güncellenemedi");
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Bu planı silmek istediğinizden emin misiniz?")) {
            return;
        }
        try {
            await deletePlan(id);
            // Refresh plan list after deletion
            const res = await getPlanList();
            const sorted = res.data.slice().sort((a, b) => new Date(b.tarih) - new Date(a.tarih));
            setPlanList(sorted);
        } catch (err) {
            console.error("Failed to delete plan:", err);
            alert("Plan silinirken bir hata oluştu");
        }
    };

  

    return (
        <div className="people-container neighborhood-container">
            <div className="fart">
             <h1 className="page-title">Bugün İşe Gelen Personeller</h1>
             <div className="comeToworks-grid">
                        {personnelWorks.data?.length > 0 ? (
                        personnelWorks.data.map((person, index) => (
                            <div key={index} className="person-card">
                            <div className="person-name">{person.adSoyad}</div>
                            </div>
                        ))
                        ) : (
                        <div className="no-personnel">Bugün işe gelen personel yok.</div>
                        )}
                    </div>                   
                    </div>
            <h1 className="page-title">Görev Planları</h1>
            <DataTable 
                key={users.length > 0 ? "users-loaded" : "users-loading"} 
                className="route-plans-table" 
                value={planList} 
                loading={loading} 
                paginator 
                rows={30} 
                stripedRows 
                responsiveLayout="scroll" 
                filterDisplay="row"
            >
                <Column field="id" header="ID" sortable body={exportIcon} />
                <Column field="ilce" header="İlçe" sortable />
                <Column field="mahalle" header="Mahalle" sortable />
                <Column 
                    field="gun" 
                    header="Gün" 
                    filter   showFilterMatchModes={false}
                    filterMatchMode="equals"   // ✅ Tam eşleşme
                    filterElement={gunFilterTemplate}
                    />
              
                <Column field="sokaklar" header="Sokaklar" body={sokaklarBody} />
                <Column 
                    field="personeller" 
                    header="Personeller" 
                    body={personellerBody} 
                />
                <Column field="personeller" header="Görev Listesi" body={gorevBody} />
                <Column header="İşlem" body={deleteBody} style={{ width: "80px" }} />
            </DataTable>

            <Dialog
               header={
                currentPersonnelId === 0 ? null : (
                  <div style={{  margin:'00px 0px 0px 20px',  fontSize:'1.3rem' }}>
                    Destek Personeli Atama
                  </div>
                )
              }
                visible={showModal}
                style={{ width: '100%', left:'auto', maxWidth:'850px' ,height: '100%'}}
                onHide={() => setShowModal(false)}
            >
                <div className="p-fluid"  style={{  padding:'20px'}}>
                    
                {currentPersonnelId !== 0 && (
                        <div className="batch-assignment-group">
                        <select
                            value={selectedUsers}
                            onChange={(e) => setSelectedUsers(e.target.value)}
                            className="filter-input batch-group-select"
                        >
                            <option value="">Destek Personeli Seçiniz</option>
                            {users.map(user => (
                            <option key={user.id} value={user.id}>
                                {user.adSoyad}
                            </option>
                            ))}
                        </select>
                        </div>
                    )}

                        <div className="p-field"  style={{  marginTop:'20px'}}>
                        <label style={{  margin:'20px 0px 20px 0px', fontSize:'1.3rem'}}>Görev Listesi</label>
                        {(() => {
                            const toplam = personnelTasks.length;
                            const alinan = personnelTasks.filter(t => t.gidildiMi === true).length;
                            const alinmayan = toplam - alinan;
                            const oran = toplam > 0 ? Math.round((alinan / toplam) * 100) : 0;
                            return (
                                <div className="task-summary-info">
                                    <span><strong>Toplam Hane:</strong> {toplam}</span>
                                    <span className="summary-divider">|</span>
                                    <span><strong>Alınan:</strong> {alinan}</span>
                                    <span className="summary-divider">|</span>
                                    <span><strong>Alınmayan:</strong> {alinmayan}</span>
                                    <span className="summary-divider">|</span>
                                    <span><strong>Tamamlanma Oranı:</strong> %{oran}</span>
                                </div>
                            );
                        })()}
                        <DataTable
                              value={personnelTasks}
                              className="p-datatable-sm"
                              scrollable
                          >

                                {currentPersonnelId !== 0 && (
                                        <Column body={checkboxBody} header={selectAllHeader} style={{ width: "50px" }} />
                                        )}
                                <Column field="id" header="Id" />
                                <Column field="adres" header="Adres" />
                                <Column field="sokak" header="Sokak" />
                                <Column field="mah" header="Mahalle" />
                                <Column field="ilce" header="İlçe" />
                                <Column
                                      header="Durum"
                                      body={(data) => {
                                          // gidildiMi === true ise tik, aksi halde (null, false, vs.) çarpı göster
                                          return data.gidildiMi === true ? (
                                              <span className="inline-flex items-center gap-1 text-sm font-medium text-green-800">
                                                  <span aria-hidden>✓</span>
                                              </span>
                                          ) : (
                                              <span className="inline-flex items-center gap-1 text-sm font-medium text-red-700" style={{ color: "#b91c1c" }}>
                                                  <span aria-hidden>✗</span>
                                              </span>
                                          );
                                      }}
                                  />
                                </DataTable>


                    </div>
                    {currentPersonnelId !== 0 && (
                            <Button
                            label="Kaydet"
                            className="p-button-success"
                            onClick={handleSave}
                            />
                        )}
                </div>
            </Dialog>
            <style jsx>{`.personnel-buttons {
                        max-width: 400px;
                    }
                        svg.p-icon.p-dropdown-clear-icon.p-clickable {
                    margin-top: -8px;
                }
                        .task-summary-info {
                            display: flex;
                            flex-wrap: wrap;
                            align-items: center;
                            gap: 8px;
                            margin: 10px 0 16px 0;
                            padding: 10px 14px;
                            background: #f1f5f9;
                            border: 1px solid #e2e8f0;
                            border-radius: 6px;
                            font-size: 0.95rem;
                            color: #334155;
                        }
                        .task-summary-info .summary-divider {
                            color: #94a3b8;
                        }
          span.p-column-title {
            color: white;
          }
            .p-datatable .p-datatable-tbody > tr > td {
                padding: 5px !important;
            }
                span.inline-flex.items-center.gap-1.text-sm.font-medium.text-green-800 {
    text-align: center;
    margin: auto;
    display: block;
}
              .p-column-header-content  .route-plans-table th svg {
                        color: #000; display:none;
                    }
.p-column-filter svg{
   color: #fff !important;
}
                    .comeToworks-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 2rem;
}

.person-card {
         display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px !important;
    transition: background-color 0.2s ease;
    width: 209px;
    padding: 10px;
    justify-content: space-between;
    background: rgba(24, 150, 78, 0.2);
    color: #18964e;
}

.person-card:hover {
  transform: scale(1.03);
}

.person-name {
  font-weight: bold;
}

.person-button {
  background-color: #4a90e2;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
}

.person-button:hover {
  background-color: #357ABD;
}

.no-personnel {
  font-style: italic;
  color: #888;
}

      `}</style>
        </div>
    );
}